import { ReactNode } from 'react';

import { cx } from '@emotion/css';
import { Table } from 'antd';
import { ColumnsType, TablePaginationConfig } from 'antd/lib/table';
import { GetRowKey } from 'antd/lib/table/interface';

import * as Styles from './MTable.styles';

export const HISTORY_PATH = 'history';

interface MTableProps<Data> {
  columns: ColumnsType<any> | undefined;
  data: Data[];
  loading?: boolean;
  onRowClick?: (record: any, rowIndex: any) => any;
  emptyState?: ReactNode | (() => ReactNode);
  pagination?: false | TablePaginationConfig | undefined;
  tableStyle?: string | undefined;
  scroll?:
    | ({
        x?: string | number | true | undefined;
        y?: string | number | undefined;
      } & {
        scrollToFirstRowOnChange?: boolean | undefined;
      })
    | undefined;
  rowKey?: string | GetRowKey<any>;
  testId?: string;
}

export function MTable<Data>({
  columns,
  data,
  loading = false,
  pagination = false,
  onRowClick,
  rowKey,
  scroll = undefined,
  tableStyle = '',
  emptyState = undefined,
  testId,
}: MTableProps<Data>) {
  return (
    <Table
      columns={columns}
      dataSource={data}
      pagination={pagination}
      loading={loading}
      scroll={scroll}
      rowKey={rowKey}
      onRow={
        onRowClick
          ? (record, rowIndex) => {
              return {
                onClick: () => onRowClick(record, rowIndex),
              };
            }
          : undefined
      }
      locale={{ emptyText: emptyState }}
      className={
        onRowClick ? cx(Styles.tableHeader, tableStyle) : cx(Styles.tableHeader, Styles.notSelectableRow, tableStyle)
      }
      data-testid={testId}
    />
  );
}
